import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { InternalAvatar } from '../../internal';
/**
 * Компонент аватарки
 *
 * Плейсхолдеры и скругления зависят от типа пользователя:
 * Люди - круглые
 * Компании - квадратные
 */

export var Avatar = /*#__PURE__*/React.forwardRef(function Avatar(props, ref) {
  return /*#__PURE__*/React.createElement(InternalAvatar, _extends({}, props, {
    ref: ref,
    highlightWidth: 4
  }));
});